import {Pipe, PipeTransform} from "@angular/core";
import {SimSystemService} from "../../api/generated/service";
import {from, Observable} from "rxjs";
import {RecorderMapping} from "../../api/generated/model";

@Pipe({
	name: "getRecordingMappingId",
	standalone: true,
})
export class GetRecordingMappingIdPipe implements PipeTransform {
	constructor(private _simSystem: SimSystemService) {}
	transform(value: string, ...args: unknown[]): Observable<RecorderMapping> {
		return from(this._simSystem.getRecorderMappingById(value));
	}
}
